"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes in a currency and returns the default symbol.
 *
 * This should _only_ be used for polyfill when formatToParts
 * is not available on old browser versions. Do _not_ use as
 * the default way of getting currency symbol,
 * use getDefaultCurrencySymbol() instead.
 *
 * @param isoCurrencyCode Three ISO letter code denoting currency
 */
var getPolyfillDefaultSymbolForCurrency = function (isoCurrencyCode) {
    switch (isoCurrencyCode.toLowerCase()) {
        case 'jpy':
            return '¥';
        default:
            return '$';
    }
};
exports.default = getPolyfillDefaultSymbolForCurrency;
